import { render, staticRenderFns } from "./FirstCertificate.vue?vue&type=template&id=3f6ebe2b&"
import script from "./FirstCertificate.vue?vue&type=script&lang=js&"
export * from "./FirstCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports